<div class="topDivClasses" [ngSwitch]="isNested">
    <div *ngSwitchCase="false" [formGroup]="formGroupInput" class="inputDivClasses">
      <!-- Label, input, hints, errors should all be inside the gb=input -->
      <!-- Replace the old error class with this new form field specific error -->
      <div [ngClass]="{ 'form-error': hasError }" class="gb-input">
        <!-- The for of the label should match the id of the input field, if no label remove from DOM -->

        <!-- Use transAttr and oxAutoFocus attributes in files that use text-input.component / [ng-model-options]="{ allowInvalid: true }" test later -->
        <input (blur)="showError()" [attr.aria-invalid]="hasError" attr.aria-label="{{label | translate}}" 
          [required]="required"
          (focus)="emitFocusState(true)"
          (blur)="emitFocusState(false)"
          [attr.aria-required]="isAriaRequired || required" [formControlName]="formControlNameInput" [oxFormatter]="validationType" [ctrl]="formGroupInput" [formCtrlNameInput]="formControlNameInput"
          [placeholder]="placeHolderText" [name]="inputName ? inputName: 'text-input'" [ngClass]="classes" [oxAutoFocus]="focusMe ? focusMe: 'false'"
          [tabindex]="tabIndex" [type]="type ? type: 'text'" [oxValidateHelper]="validationType" dir="auto" [id]="id" [class]="inputElClasses" />
          <label class="gb-input-label hover" *ngIf="label" [for]="id">
            <span *ngIf="iconLocation" alt="location pin icon" aria-hidden="true" class="icon-graphic-location"></span>
            <span [translate]="label"></span>
            <sup *ngIf="sup">{{ supValue }}</sup>
          </label>
        <div *ngIf="!showCustomError && hasError" class="gb-error-text-container">
          <!-- animate-underline span is for GM Brand only -->
          <span class="animate-underline"></span>
          <span *ngIf="formGroupInput.controls[formControlNameInput].errors?.['minlength']" [translate]="'error_minlength'" [translateParams]="{minLength: minLength}"
            aria-atomic="true" class="gb-error-text gb-error-img" role="alert">
          </span>
          <span *ngIf="formGroupInput.controls[formControlNameInput].errors?.['maxlength']" [translate]="'error_maxlength'" [translateParams]="{maxLength: maxLength}"
                aria-atomic="true" class="gb-error-text gb-error-img" role="alert">
          </span>
          <span *ngIf="
                  formGroupInput.controls[formControlNameInput].errors?.['pattern'] ||
                  formGroupInput.controls[formControlNameInput].errors?.['invalid']
                  " [translate]="'error_invalid'" aria-atomic="true" class="gb-error-text gb-error-img" role="alert">
          </span>
          <span *ngIf="
                    !showCustomError && formGroupInput.controls[formControlNameInput].errors?.['required']
                  " [translate]="'error_required'" aria-atomic="true" class="gb-error-text gb-error-img" role="alert">
          </span>
        </div>
      </div>
  </div>
</div>
